module.exports = __webpack_public_path__ + "img/class5.e02e75f4.png";